// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../node_modules/postcss-loader/dist/cjs.js!../../style/theme.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header_PW0Rd {
  padding: 10px 26px 10px 20px;
  text-align: right;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  border-bottom: 5px solid #F4F6FA;
}

.headerRow_fc29P {
  width : 100%;
}

.label_VsVn5 {
  width : 60px;
}

.itemName_qHtb1 {
  width : 100%;
  margin-bottom: var( --size-padSmall, 4px );
}

.apiKey_f4eog, .secret_gH_JP, .resource_hcSq6 {
  flex:1;
  text-overflow: ellipsis;
  padding : 0 10px;
  color : var( --light-grey );
  width: 100%;
}

.apiAccessItemArea_WRirS {
  align-items: flex-start !important;
}

.apiAccessContent_AsaxK > * {
  margin-top : 8px;
}

.apiAccessItem_jT0fx:hover { 
  background : white;
}

.content_GLyHn {
  padding : 0 0;

  .addApiAccess_lNTsN {
    margin-bottom: 10px;
    align-self:left;
    align-items: flex-start;
  }

  .apiAccessHeader_tiAXm {
    border-top: 5px solid var( --background );
    border-bottom: 5px solid var( --background );
    padding: 10px 26px 10px 10px;
  }

  .settingsHeader_bK59A {
    border-bottom: 5px solid var( --background );
    padding: 10px 26px 10px 10px;

  }

  .apiAccessItem_jT0fx + .apiAccessItem_jT0fx {
    border-top: 1px solid var( --lighter-grey );
  }

  .apiAccessItem_jT0fx:hover {
    background : white;
  }

  .apiAccessContent_AsaxK {
    padding-left : 0px;
  }

  .apiKeyItem_fFe8i, .secretItem_zXMdv {
    display : flex;
    flex-direction : row;
    justify-content : space-between;
    align-items : center;
    width : 100%;
  

    label {
      margin : 0;
      width : 50px;
    }
  }

  .apiAccessDisabled_ku6KD:hover, .apiAccessDisabled_ku6KD:active, .apiAccessDisabled_ku6KD:focus, .apiAccessDisabled_ku6KD:focus:hover, .apiAccessDisabled_ku6KD:focus:active
  .apiAccessEnabled_VzhHV:hover, .apiAccessEnabled_VzhHV:active, .apiAccessEnabled_VzhHV:focus, .apiAccessEnabled_VzhHV:focus:hover, .apiAccessEnabled_VzhHV:focus:active {
    outline : none;
  }

  .apiAccessEnabled_VzhHV:active, .apiAccessDisabled_ku6KD:active {
    background:var( --lighter-grey );
  }

  .apiAccessDisabled_ku6KD {
    color : var( --light-grey ) !important;
  }

  .apiAccessEnabled_VzhHV {
    color : var( --green ) !important;
  }

}

.editor_Z9pwe {
  border-left : 4px solid var( --color-base100, #eeeeee );
}`, "",{"version":3,"sources":["webpack://./src/screens/clientId/ClientIdScreen.css"],"names":[],"mappings":"AAEA;EACE,4BAA4B;EAC5B,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,0CAA0C;AAC5C;;AAEA;EACE,MAAM;EACN,uBAAuB;EACvB,gBAAgB;EAChB,2BAA2B;EAC3B,WAAW;AACb;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;;EAEb;IACE,mBAAmB;IACnB,eAAe;IACf,uBAAuB;EACzB;;EAEA;IACE,yCAAyC;IACzC,4CAA4C;IAC5C,4BAA4B;EAC9B;;EAEA;IACE,4CAA4C;IAC5C,4BAA4B;;EAE9B;;EAEA;IACE,2CAA2C;EAC7C;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,cAAc;IACd,oBAAoB;IACpB,+BAA+B;IAC/B,oBAAoB;IACpB,YAAY;;;IAGZ;MACE,UAAU;MACV,YAAY;IACd;EACF;;EAEA;;IAEE,cAAc;EAChB;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,sCAAsC;EACxC;;EAEA;IACE,iCAAiC;EACnC;;AAEF;;AAEA;EACE,uDAAuD;AACzD","sourcesContent":["@import \"../../style/theme.css\";\n\n.header {\n  padding: 10px 26px 10px 20px;\n  text-align: right;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  border-bottom: 5px solid #F4F6FA;\n}\n\n.headerRow {\n  width : 100%;\n}\n\n.label {\n  width : 60px;\n}\n\n.itemName {\n  width : 100%;\n  margin-bottom: var( --size-padSmall, 4px );\n}\n\n.apiKey, .secret, .resource {\n  flex:1;\n  text-overflow: ellipsis;\n  padding : 0 10px;\n  color : var( --light-grey );\n  width: 100%;\n}\n\n.apiAccessItemArea {\n  align-items: flex-start !important;\n}\n\n.apiAccessContent > * {\n  margin-top : 8px;\n}\n\n.apiAccessItem:hover { \n  background : white;\n}\n\n.content {\n  padding : 0 0;\n\n  .addApiAccess {\n    margin-bottom: 10px;\n    align-self:left;\n    align-items: flex-start;\n  }\n\n  .apiAccessHeader {\n    border-top: 5px solid var( --background );\n    border-bottom: 5px solid var( --background );\n    padding: 10px 26px 10px 10px;\n  }\n\n  .settingsHeader {\n    border-bottom: 5px solid var( --background );\n    padding: 10px 26px 10px 10px;\n\n  }\n\n  .apiAccessItem + .apiAccessItem {\n    border-top: 1px solid var( --lighter-grey );\n  }\n\n  .apiAccessItem:hover {\n    background : white;\n  }\n\n  .apiAccessContent {\n    padding-left : 0px;\n  }\n\n  .apiKeyItem, .secretItem {\n    display : flex;\n    flex-direction : row;\n    justify-content : space-between;\n    align-items : center;\n    width : 100%;\n  \n\n    label {\n      margin : 0;\n      width : 50px;\n    }\n  }\n\n  .apiAccessDisabled:hover, .apiAccessDisabled:active, .apiAccessDisabled:focus, .apiAccessDisabled:focus:hover, .apiAccessDisabled:focus:active\n  .apiAccessEnabled:hover, .apiAccessEnabled:active, .apiAccessEnabled:focus, .apiAccessEnabled:focus:hover, .apiAccessEnabled:focus:active {\n    outline : none;\n  }\n\n  .apiAccessEnabled:active, .apiAccessDisabled:active {\n    background:var( --lighter-grey );\n  }\n\n  .apiAccessDisabled {\n    color : var( --light-grey ) !important;\n  }\n\n  .apiAccessEnabled {\n    color : var( --green ) !important;\n  }\n\n}\n\n.editor {\n  border-left : 4px solid var( --color-base100, #eeeeee );\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `header_PW0Rd`,
	"headerRow": `headerRow_fc29P`,
	"label": `label_VsVn5`,
	"itemName": `itemName_qHtb1`,
	"apiKey": `apiKey_f4eog`,
	"secret": `secret_gH_JP`,
	"resource": `resource_hcSq6`,
	"apiAccessItemArea": `apiAccessItemArea_WRirS`,
	"apiAccessContent": `apiAccessContent_AsaxK`,
	"apiAccessItem": `apiAccessItem_jT0fx`,
	"content": `content_GLyHn`,
	"addApiAccess": `addApiAccess_lNTsN`,
	"apiAccessHeader": `apiAccessHeader_tiAXm`,
	"settingsHeader": `settingsHeader_bK59A`,
	"apiKeyItem": `apiKeyItem_fFe8i`,
	"secretItem": `secretItem_zXMdv`,
	"apiAccessDisabled": `apiAccessDisabled_ku6KD`,
	"apiAccessEnabled": `apiAccessEnabled_VzhHV`,
	"editor": `editor_Z9pwe`
};
export default ___CSS_LOADER_EXPORT___;
